module.exports = __webpack_public_path__ + "static/media/trofeo3.87380848.png";